import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MembershipModal from './MembershipModal';
import ScrollToTop from './ScrollToTop';
import { Toaster } from './ui/toaster';

const PublicLayout = () => {
    const [showMembershipModal, setShowMembershipModal] = useState(false);

    return (
        <div className="App">
            <ScrollToTop />
            <Header onMembershipClick={() => setShowMembershipModal(true)} />
            <MembershipModal
                isOpen={showMembershipModal}
                onClose={() => setShowMembershipModal(false)}
            />
            <main>
                <Outlet />
            </main>
            <Footer />
            <Toaster />
        </div>
    );
};

export default PublicLayout;
